import { FC } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";

export interface FreeSubheadingProps {
    returnString?: boolean;
}

export const FreeSubheading: FC<FreeSubheadingProps> = ({ returnString }) => {
    const intl = useIntl();

    const subHeaderText = intl.formatMessage({
        id: "signupForm.accountCreation.subHeaderText",
        defaultMessage: "It’s free for up to 10 users - no credit card needed."
    });

    return returnString ? (
        subHeaderText
    ) : (
        <p css={subHeaderCss}>{subHeaderText}</p>
    );
};
const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
